import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		button: {
			//maxWidth: '250px',
		},
		gridItemButton: {
			margin: '4px',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
		},
		image: {
			width: '100%',
			maxHeight: '600px',
			objectFit: 'contain',
		},
		headerTitle: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
			fontSize: '24px',
			margin: '8px 0px 24px 0px',
			fontWeight: 'bold',
			[theme.breakpoints.down('md')]: {
				fontSize: '16px',
			},
		},
	})
